import BreadcrumbsMapper from '../components/Breadcrumbs/viewer/Breadcrumbs.mapper';
import CollapsibleTextMapper from '../components/CollapsibleText/viewer/CollapsibleText.mapper';
import MegaMenuContainerItemMapper from '../components/MegaMenuContainerItem/viewer/MegaMenuContainerItem.mapper';
import PopoverMenuMapper from '../components/PopoverMenu/viewer/PopoverMenu.mapper';
import ProGalleryMapper from '../components/ProGallery/viewer/ProGallery.mapper';
import RangeSliderMapper from '../components/RangeSlider/viewer/RangeSlider.mapper';
import SlotsPlaceholderMapper from '../components/SlotsPlaceholder/viewer/SlotsPlaceholder.mapper';
import StretchedContainerMapper from '../components/StretchedContainer/viewer/StretchedContainer.mapper';
import TestCompMapper from '../components/TestComp/viewer/TestComp.mapper';
import AccordionMapper from '@wix/thunderbolt-elements/src/components/Accordion/viewer/Accordion.mapper';
import AddressInputMapper from '@wix/thunderbolt-elements/src/components/AddressInput/viewer/AddressInput.mapper';
import AudioPlayerMapper from '@wix/thunderbolt-elements/src/components/AudioPlayer/viewer/AudioPlayer.mapper';
import BackToTopButtonMapper from '@wix/thunderbolt-elements/src/components/BackToTopButton/viewer/BackToTopButton.mapper';
import CaptchaMapper from '@wix/thunderbolt-elements/src/components/Captcha/viewer/Captcha.mapper';
import CheckboxMapper from '@wix/thunderbolt-elements/src/components/Checkbox/viewer/Checkbox.mapper';
import CheckboxGroupMapper from '@wix/thunderbolt-elements/src/components/CheckboxGroup/viewer/CheckboxGroup.mapper';
import ClassicSectionMapper from '@wix/thunderbolt-elements/src/components/ClassicSection/viewer/ClassicSection.mapper';
import CollageMapper from '@wix/thunderbolt-elements/src/components/Collage/viewer/Collage.mapper';
import ColumnMapper from '@wix/thunderbolt-elements/src/components/Column/viewer/Column.mapper';
import ComboBoxInputMapper from '@wix/thunderbolt-elements/src/components/ComboBoxInput/viewer/ComboBoxInput.mapper';
import CustomElementComponentMapper from '@wix/thunderbolt-elements/src/components/CustomElement/CustomElementComponent/viewer/CustomElementComponent.mapper';
import DatePickerMapper from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/DatePicker.mapper';
import DatePickerCalendarMapper from '@wix/thunderbolt-elements/src/components/DatePickerCalendar/viewer/DatePickerCalendar.mapper';
import DisqusCommentsMapper from '@wix/thunderbolt-elements/src/components/DisqusComments/viewer/DisqusComments.mapper';
import DropDownMenuMapper from '@wix/thunderbolt-elements/src/components/DropDownMenu/viewer/DropDownMenu.mapper';
import FacebookShareMapper from '@wix/thunderbolt-elements/src/components/FacebookShare/viewer/FacebookShare.mapper';
import FileUploaderMapper from '@wix/thunderbolt-elements/src/components/FileUploader/viewer/FileUploader.mapper';
import FlashComponentMapper from '@wix/thunderbolt-elements/src/components/FlashComponent/viewer/FlashComponent.mapper';
import FlickrBadgeWidgetMapper from '@wix/thunderbolt-elements/src/components/FlickrBadgeWidget/viewer/FlickrBadgeWidget.mapper';
import FooterContainerMapper from '@wix/thunderbolt-elements/src/components/FooterContainer/viewer/FooterContainer.mapper';
import FreemiumBannerDesktopMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/FreemiumBannerDesktop/viewer/FreemiumBannerDesktop.mapper';
import FreestyleMapper from '@wix/thunderbolt-elements/src/components/Freestyle/viewer/Freestyle.mapper';
import GoogleMapMapper from '@wix/thunderbolt-elements/src/components/GoogleMap/viewer/GoogleMap.mapper';
import GridMapper from '@wix/thunderbolt-elements/src/components/Grid/viewer/Grid.mapper';
import HeaderContainerMapper from '@wix/thunderbolt-elements/src/components/HeaderContainer/viewer/HeaderContainer.mapper';
import HoneycombMapper from '@wix/thunderbolt-elements/src/components/Honeycomb/viewer/Honeycomb.mapper';
import HtmlComponentMapper from '@wix/thunderbolt-elements/src/components/HtmlComponent/viewer/HtmlComponent.mapper';
import ImageButtonMapper from '@wix/thunderbolt-elements/src/components/ImageButton/viewer/ImageButton.mapper';
import ImageXMapper from '@wix/thunderbolt-elements/src/components/ImageX/viewer/ImageX.mapper';
import ImpressMapper from '@wix/thunderbolt-elements/src/components/Impress/viewer/Impress.mapper';
import ItunesButtonMapper from '@wix/thunderbolt-elements/src/components/ItunesButton/viewer/ItunesButton.mapper';
import LanguageSelectorMapper from '@wix/thunderbolt-elements/src/components/LanguageSelector/viewer/LanguageSelector.mapper';
import LineShareButtonMapper from '@wix/thunderbolt-elements/src/components/LineShareButton/viewer/LineShareButton.mapper';
import LinkBarMapper from '@wix/thunderbolt-elements/src/components/LinkBar/viewer/LinkBar.mapper';
import LoginButtonMapper from '@wix/thunderbolt-elements/src/components/LoginButton/viewer/LoginButton.mapper';
import LoginSocialBarMapper from '@wix/thunderbolt-elements/src/components/LoginSocialBar/viewer/LoginSocialBar.mapper';
import MasonryMapper from '@wix/thunderbolt-elements/src/components/Masonry/viewer/Masonry.mapper';
import HoverBoxMapper from '@wix/thunderbolt-elements/src/components/MediaContainers/HoverBox/viewer/HoverBox.mapper';
import MenuContainerMapper from '@wix/thunderbolt-elements/src/components/MenuContainer/viewer/MenuContainer.mapper';
import MenuToggleMapper from '@wix/thunderbolt-elements/src/components/MenuToggle/viewer/MenuToggle.mapper';
import MultiStateBoxMapper from '@wix/thunderbolt-elements/src/components/MultiStateBox/viewer/MultiStateBox.mapper';
import MusicPlayerMapper from '@wix/thunderbolt-elements/src/components/MusicPlayer/viewer/MusicPlayer.mapper';
import MatrixGalleryMapper from '@wix/thunderbolt-elements/src/components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.mapper';
import PaginatedGridGalleryMapper from '@wix/thunderbolt-elements/src/components/NativeGalleries/PaginatedGridGallery/viewer/PaginatedGridGallery.mapper';
import SliderGalleryMapper from '@wix/thunderbolt-elements/src/components/NativeGalleries/SliderGallery/viewer/SliderGallery.mapper';
import SlideShowGalleryMapper from '@wix/thunderbolt-elements/src/components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.mapper';
import PaginationMapper from '@wix/thunderbolt-elements/src/components/Pagination/viewer/Pagination.mapper';
import PayPalButtonMapper from '@wix/thunderbolt-elements/src/components/PayPalButton/viewer/PayPalButton.mapper';
import PinItPinWidgetMapper from '@wix/thunderbolt-elements/src/components/PinItPinWidget/viewer/PinItPinWidget.mapper';
import PinterestPinItMapper from '@wix/thunderbolt-elements/src/components/PinterestPinIt/viewer/PinterestPinIt.mapper';
import ProgressBarMapper from '@wix/thunderbolt-elements/src/components/ProgressBar/viewer/ProgressBar.mapper';
import QuickActionBarMapper from '@wix/thunderbolt-elements/src/components/QuickActionBar/viewer/QuickActionBar.mapper';
import RadioGroupMapper from '@wix/thunderbolt-elements/src/components/RadioGroup/viewer/RadioGroup.mapper';
import RatingsDisplayMapper from '@wix/thunderbolt-elements/src/components/RatingsDisplay/viewer/RatingsDisplay.mapper';
import RatingsInputMapper from '@wix/thunderbolt-elements/src/components/RatingsInput/viewer/RatingsInput.mapper';
import ResponsivePopupContainerMapper from '@wix/thunderbolt-elements/src/components/ResponsivePopupContainer/viewer/ResponsivePopupContainer.mapper';
import RichTextBoxMapper from '@wix/thunderbolt-elements/src/components/RichTextBox/viewer/RichTextBox.mapper';
import RSSButtonMapper from '@wix/thunderbolt-elements/src/components/RSSButton/viewer/RSSButton.mapper';
import SearchBoxMapper from '@wix/thunderbolt-elements/src/components/SearchBox/viewer/SearchBox.mapper';
import HeaderSectionMapper from '@wix/thunderbolt-elements/src/components/Sections/HeaderSection/viewer/HeaderSection.mapper';
import SectionMapper from '@wix/thunderbolt-elements/src/components/Sections/Section/viewer/Section.mapper';
import SelectionTagsListMapper from '@wix/thunderbolt-elements/src/components/SelectionTagsList/viewer/SelectionTagsList.mapper';
import SeoTpaGalleryMapper from '@wix/thunderbolt-elements/src/components/SeoTpaGallery/viewer/SeoTpaGallery.mapper';
import SignatureInputMapper from '@wix/thunderbolt-elements/src/components/SignatureInput/viewer/SignatureInput.mapper';
import SingleAudioPlayerMapper from '@wix/thunderbolt-elements/src/components/SingleAudioPlayer/viewer/SingleAudioPlayer.mapper';
import SiteButtonMapper from '@wix/thunderbolt-elements/src/components/SiteButton/viewer/SiteButton.mapper';
import SliderMapper from '@wix/thunderbolt-elements/src/components/Slider/viewer/Slider.mapper';
import SlideShowContainerMapper from '@wix/thunderbolt-elements/src/components/SlideShowContainer/viewer/SlideShowContainer.mapper';
import SlideShowSlideMapper from '@wix/thunderbolt-elements/src/components/SlideShowSlide/viewer/SlideShowSlide.mapper';
import SocialAuthMapper from '@wix/thunderbolt-elements/src/components/SocialAuth/viewer/SocialAuth.mapper';
import SoundCloudWidgetMapper from '@wix/thunderbolt-elements/src/components/SoundCloudWidget/viewer/SoundCloudWidget.mapper';
import SpotifyFollowMapper from '@wix/thunderbolt-elements/src/components/SpotifyFollow/viewer/SpotifyFollow.mapper';
import SpotifyPlayerMapper from '@wix/thunderbolt-elements/src/components/SpotifyPlayer/viewer/SpotifyPlayer.mapper';
import StateBoxMapper from '@wix/thunderbolt-elements/src/components/StateBox/viewer/StateBox.mapper';
import StripColumnsContainerMapper from '@wix/thunderbolt-elements/src/components/StripColumnsContainer/viewer/StripColumnsContainer.mapper';
import StripShowcaseMapper from '@wix/thunderbolt-elements/src/components/StripShowcase/viewer/StripShowcase.mapper';
import StripSlideshowMapper from '@wix/thunderbolt-elements/src/components/StripSlideshow/viewer/StripSlideshow.mapper';
import StylableButtonMapper from '@wix/thunderbolt-elements/src/components/StylableButton/viewer/StylableButton.mapper';
import StylableHorizontalMenuMapper from '@wix/thunderbolt-elements/src/components/StylableHorizontalMenu/viewer/StylableHorizontalMenu.mapper';
import TextAreaInputMapper from '@wix/thunderbolt-elements/src/components/TextAreaInput/viewer/TextAreaInput.mapper';
import TextInputMapper from '@wix/thunderbolt-elements/src/components/TextInput/viewer/TextInput.mapper';
import ThumbnailsMapper from '@wix/thunderbolt-elements/src/components/Thumbnails/viewer/Thumbnails.mapper';
import TimePickerMapper from '@wix/thunderbolt-elements/src/components/TimePicker/viewer/TimePicker.mapper';
import ToggleSwitchMapper from '@wix/thunderbolt-elements/src/components/ToggleSwitch/viewer/ToggleSwitch.mapper';
import TPA3DCarouselMapper from '@wix/thunderbolt-elements/src/components/TPA3DCarousel/viewer/TPA3DCarousel.mapper';
import TPA3DGalleryMapper from '@wix/thunderbolt-elements/src/components/TPA3DGallery/viewer/TPA3DGallery.mapper';
import VerticalAnchorsMenuMapper from '@wix/thunderbolt-elements/src/components/VerticalAnchorsMenu/viewer/VerticalAnchorsMenu.mapper';
import VerticalMenuMapper from '@wix/thunderbolt-elements/src/components/VerticalMenu/viewer/VerticalMenu.mapper';
import VideoMapper from '@wix/thunderbolt-elements/src/components/VideoLegacy/viewer/VideoLegacy.mapper';
import VideoPlayerMapper from '@wix/thunderbolt-elements/src/components/VideoPlayer/viewer/VideoPlayer.mapper';
import VKShareButtonMapper from '@wix/thunderbolt-elements/src/components/VKShareButton/viewer/VKShareButton.mapper';
import WFacebookCommentMapper from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/WFacebookComment.mapper';
import WFacebookLikeMapper from '@wix/thunderbolt-elements/src/components/WFacebookLike/viewer/WFacebookLike.mapper';
import WRichTextMapper from '@wix/thunderbolt-elements/src/components/WRichText/viewer/WRichText.mapper';
import WTwitterFollowMapper from '@wix/thunderbolt-elements/src/components/WTwitterFollow/viewer/WTwitterFollow.mapper';
import WTwitterTweetMapper from '@wix/thunderbolt-elements/src/components/WTwitterTweet/viewer/WTwitterTweet.mapper';
import YouTubeSubscribeButtonMapper from '@wix/thunderbolt-elements/src/components/YouTubeSubscribeButton/viewer/YouTubeSubscribeButton.mapper';
import BlocksDemoMapper from '../.components/BlocksDemo/viewer/BlocksDemo.mapper';
import LottieEmbedMapper from '../.components/LottieEmbed/viewer/LottieEmbed.mapper';
import MockLibCompMapper from '../.components/MockLibComp/viewer/MockLibComp.mapper';
import SimpleCardMapper from '../.components/SimpleCard/viewer/SimpleCard.mapper';
import StepperMapper from '../.components/Stepper/viewer/Stepper.mapper';


const Breadcrumbs = {
  mapper: BreadcrumbsMapper
};

const CollapsibleText = {
  mapper: CollapsibleTextMapper
};

const MegaMenuContainerItem = {
  mapper: MegaMenuContainerItemMapper
};

const PopoverMenu = {
  mapper: PopoverMenuMapper
};

const ProGallery = {
  mapper: ProGalleryMapper
};

const RangeSlider = {
  mapper: RangeSliderMapper
};

const SlotsPlaceholder = {
  mapper: SlotsPlaceholderMapper
};

const StretchedContainer = {
  mapper: StretchedContainerMapper
};

const TestComp = {
  mapper: TestCompMapper
};

const Accordion = {
  mapper: AccordionMapper
};

const AddressInput = {
  mapper: AddressInputMapper
};

const AudioPlayer = {
  mapper: AudioPlayerMapper
};

const BackToTopButton = {
  mapper: BackToTopButtonMapper
};

const Captcha = {
  mapper: CaptchaMapper
};

const Checkbox = {
  mapper: CheckboxMapper
};

const CheckboxGroup = {
  mapper: CheckboxGroupMapper
};

const ClassicSection = {
  mapper: ClassicSectionMapper
};

const Collage = {
  mapper: CollageMapper
};

const Column = {
  mapper: ColumnMapper
};

const ComboBoxInput = {
  mapper: ComboBoxInputMapper
};

const CustomElementComponent = {
  mapper: CustomElementComponentMapper
};

const DatePicker = {
  mapper: DatePickerMapper
};

const DatePickerCalendar = {
  mapper: DatePickerCalendarMapper
};

const DisqusComments = {
  mapper: DisqusCommentsMapper
};

const DropDownMenu = {
  mapper: DropDownMenuMapper
};

const FacebookShare = {
  mapper: FacebookShareMapper
};

const FileUploader = {
  mapper: FileUploaderMapper
};

const FlashComponent = {
  mapper: FlashComponentMapper
};

const FlickrBadgeWidget = {
  mapper: FlickrBadgeWidgetMapper
};

const FooterContainer = {
  mapper: FooterContainerMapper
};

const FreemiumBannerDesktop = {
  mapper: FreemiumBannerDesktopMapper
};

const Freestyle = {
  mapper: FreestyleMapper
};

const GoogleMap = {
  mapper: GoogleMapMapper
};

const Grid = {
  mapper: GridMapper
};

const HeaderContainer = {
  mapper: HeaderContainerMapper
};

const Honeycomb = {
  mapper: HoneycombMapper
};

const HtmlComponent = {
  mapper: HtmlComponentMapper
};

const ImageButton = {
  mapper: ImageButtonMapper
};

const ImageX = {
  mapper: ImageXMapper
};

const Impress = {
  mapper: ImpressMapper
};

const ItunesButton = {
  mapper: ItunesButtonMapper
};

const LanguageSelector = {
  mapper: LanguageSelectorMapper
};

const LineShareButton = {
  mapper: LineShareButtonMapper
};

const LinkBar = {
  mapper: LinkBarMapper
};

const LoginButton = {
  mapper: LoginButtonMapper
};

const LoginSocialBar = {
  mapper: LoginSocialBarMapper
};

const Masonry = {
  mapper: MasonryMapper
};

const HoverBox = {
  mapper: HoverBoxMapper
};

const MenuContainer = {
  mapper: MenuContainerMapper
};

const MenuToggle = {
  mapper: MenuToggleMapper
};

const MultiStateBox = {
  mapper: MultiStateBoxMapper
};

const MusicPlayer = {
  mapper: MusicPlayerMapper
};

const MatrixGallery = {
  mapper: MatrixGalleryMapper
};

const PaginatedGridGallery = {
  mapper: PaginatedGridGalleryMapper
};

const SliderGallery = {
  mapper: SliderGalleryMapper
};

const SlideShowGallery = {
  mapper: SlideShowGalleryMapper
};

const Pagination = {
  mapper: PaginationMapper
};

const PayPalButton = {
  mapper: PayPalButtonMapper
};

const PinItPinWidget = {
  mapper: PinItPinWidgetMapper
};

const PinterestPinIt = {
  mapper: PinterestPinItMapper
};

const ProgressBar = {
  mapper: ProgressBarMapper
};

const QuickActionBar = {
  mapper: QuickActionBarMapper
};

const RadioGroup = {
  mapper: RadioGroupMapper
};

const RatingsDisplay = {
  mapper: RatingsDisplayMapper
};

const RatingsInput = {
  mapper: RatingsInputMapper
};

const ResponsivePopupContainer = {
  mapper: ResponsivePopupContainerMapper
};

const RichTextBox = {
  mapper: RichTextBoxMapper
};

const RSSButton = {
  mapper: RSSButtonMapper
};

const SearchBox = {
  mapper: SearchBoxMapper
};

const HeaderSection = {
  mapper: HeaderSectionMapper
};

const Section = {
  mapper: SectionMapper
};

const SelectionTagsList = {
  mapper: SelectionTagsListMapper
};

const SeoTpaGallery = {
  mapper: SeoTpaGalleryMapper
};

const SignatureInput = {
  mapper: SignatureInputMapper
};

const SingleAudioPlayer = {
  mapper: SingleAudioPlayerMapper
};

const SiteButton = {
  mapper: SiteButtonMapper
};

const Slider = {
  mapper: SliderMapper
};

const SlideShowContainer = {
  mapper: SlideShowContainerMapper
};

const SlideShowSlide = {
  mapper: SlideShowSlideMapper
};

const SocialAuth = {
  mapper: SocialAuthMapper
};

const SoundCloudWidget = {
  mapper: SoundCloudWidgetMapper
};

const SpotifyFollow = {
  mapper: SpotifyFollowMapper
};

const SpotifyPlayer = {
  mapper: SpotifyPlayerMapper
};

const StateBox = {
  mapper: StateBoxMapper
};

const StripColumnsContainer = {
  mapper: StripColumnsContainerMapper
};

const StripShowcase = {
  mapper: StripShowcaseMapper
};

const StripSlideshow = {
  mapper: StripSlideshowMapper
};

const StylableButton = {
  mapper: StylableButtonMapper
};

const StylableHorizontalMenu = {
  mapper: StylableHorizontalMenuMapper
};

const TextAreaInput = {
  mapper: TextAreaInputMapper
};

const TextInput = {
  mapper: TextInputMapper
};

const Thumbnails = {
  mapper: ThumbnailsMapper
};

const TimePicker = {
  mapper: TimePickerMapper
};

const ToggleSwitch = {
  mapper: ToggleSwitchMapper
};

const TPA3DCarousel = {
  mapper: TPA3DCarouselMapper
};

const TPA3DGallery = {
  mapper: TPA3DGalleryMapper
};

const VerticalAnchorsMenu = {
  mapper: VerticalAnchorsMenuMapper
};

const VerticalMenu = {
  mapper: VerticalMenuMapper
};

const Video = {
  mapper: VideoMapper
};

const VideoPlayer = {
  mapper: VideoPlayerMapper
};

const VKShareButton = {
  mapper: VKShareButtonMapper
};

const WFacebookComment = {
  mapper: WFacebookCommentMapper
};

const WFacebookLike = {
  mapper: WFacebookLikeMapper
};

const WRichText = {
  mapper: WRichTextMapper
};

const WTwitterFollow = {
  mapper: WTwitterFollowMapper
};

const WTwitterTweet = {
  mapper: WTwitterTweetMapper
};

const YouTubeSubscribeButton = {
  mapper: YouTubeSubscribeButtonMapper
};

const BlocksDemo = {
  mapper: BlocksDemoMapper
};

const LottieEmbed = {
  mapper: LottieEmbedMapper
};

const MockLibComp = {
  mapper: MockLibCompMapper
};

const SimpleCard = {
  mapper: SimpleCardMapper
};

const Stepper = {
  mapper: StepperMapper
};


export const components = {
  ['Breadcrumbs']: Breadcrumbs,
  ['CollapsibleText']: CollapsibleText,
  ['MegaMenuContainerItem']: MegaMenuContainerItem,
  ['PopoverMenu']: PopoverMenu,
  ['ProGallery']: ProGallery,
  ['RangeSlider']: RangeSlider,
  ['SlotsPlaceholder']: SlotsPlaceholder,
  ['StretchedContainer']: StretchedContainer,
  ['TestComp']: TestComp,
  ['Accordion']: Accordion,
  ['AddressInput']: AddressInput,
  ['AudioPlayer']: AudioPlayer,
  ['BackToTopButton']: BackToTopButton,
  ['Captcha']: Captcha,
  ['Checkbox']: Checkbox,
  ['CheckboxGroup']: CheckboxGroup,
  ['ClassicSection']: ClassicSection,
  ['Collage']: Collage,
  ['Column']: Column,
  ['ComboBoxInput']: ComboBoxInput,
  ['CustomElementComponent']: CustomElementComponent,
  ['DatePicker']: DatePicker,
  ['DatePickerCalendar']: DatePickerCalendar,
  ['DisqusComments']: DisqusComments,
  ['DropDownMenu']: DropDownMenu,
  ['FacebookShare']: FacebookShare,
  ['FileUploader']: FileUploader,
  ['FlashComponent']: FlashComponent,
  ['FlickrBadgeWidget']: FlickrBadgeWidget,
  ['FooterContainer']: FooterContainer,
  ['FreemiumBannerDesktop']: FreemiumBannerDesktop,
  ['Freestyle']: Freestyle,
  ['GoogleMap']: GoogleMap,
  ['Grid']: Grid,
  ['HeaderContainer']: HeaderContainer,
  ['Honeycomb']: Honeycomb,
  ['HtmlComponent']: HtmlComponent,
  ['ImageButton']: ImageButton,
  ['ImageX']: ImageX,
  ['Impress']: Impress,
  ['ItunesButton']: ItunesButton,
  ['LanguageSelector']: LanguageSelector,
  ['LineShareButton']: LineShareButton,
  ['LinkBar']: LinkBar,
  ['LoginButton']: LoginButton,
  ['LoginSocialBar']: LoginSocialBar,
  ['Masonry']: Masonry,
  ['HoverBox']: HoverBox,
  ['MenuContainer']: MenuContainer,
  ['MenuToggle']: MenuToggle,
  ['MultiStateBox']: MultiStateBox,
  ['MusicPlayer']: MusicPlayer,
  ['MatrixGallery']: MatrixGallery,
  ['PaginatedGridGallery']: PaginatedGridGallery,
  ['SliderGallery']: SliderGallery,
  ['SlideShowGallery']: SlideShowGallery,
  ['Pagination']: Pagination,
  ['PayPalButton']: PayPalButton,
  ['PinItPinWidget']: PinItPinWidget,
  ['PinterestPinIt']: PinterestPinIt,
  ['ProgressBar']: ProgressBar,
  ['QuickActionBar']: QuickActionBar,
  ['RadioGroup']: RadioGroup,
  ['RatingsDisplay']: RatingsDisplay,
  ['RatingsInput']: RatingsInput,
  ['ResponsivePopupContainer']: ResponsivePopupContainer,
  ['RichTextBox']: RichTextBox,
  ['RSSButton']: RSSButton,
  ['SearchBox']: SearchBox,
  ['HeaderSection']: HeaderSection,
  ['Section']: Section,
  ['SelectionTagsList']: SelectionTagsList,
  ['SeoTpaGallery']: SeoTpaGallery,
  ['SignatureInput']: SignatureInput,
  ['SingleAudioPlayer']: SingleAudioPlayer,
  ['SiteButton']: SiteButton,
  ['Slider']: Slider,
  ['SlideShowContainer']: SlideShowContainer,
  ['SlideShowSlide']: SlideShowSlide,
  ['SocialAuth']: SocialAuth,
  ['SoundCloudWidget']: SoundCloudWidget,
  ['SpotifyFollow']: SpotifyFollow,
  ['SpotifyPlayer']: SpotifyPlayer,
  ['StateBox']: StateBox,
  ['StripColumnsContainer']: StripColumnsContainer,
  ['StripShowcase']: StripShowcase,
  ['StripSlideshow']: StripSlideshow,
  ['StylableButton']: StylableButton,
  ['StylableHorizontalMenu']: StylableHorizontalMenu,
  ['TextAreaInput']: TextAreaInput,
  ['TextInput']: TextInput,
  ['Thumbnails']: Thumbnails,
  ['TimePicker']: TimePicker,
  ['ToggleSwitch']: ToggleSwitch,
  ['TPA3DCarousel']: TPA3DCarousel,
  ['TPA3DGallery']: TPA3DGallery,
  ['VerticalAnchorsMenu']: VerticalAnchorsMenu,
  ['VerticalMenu']: VerticalMenu,
  ['Video']: Video,
  ['VideoPlayer']: VideoPlayer,
  ['VKShareButton']: VKShareButton,
  ['WFacebookComment']: WFacebookComment,
  ['WFacebookLike']: WFacebookLike,
  ['WRichText']: WRichText,
  ['WTwitterFollow']: WTwitterFollow,
  ['WTwitterTweet']: WTwitterTweet,
  ['YouTubeSubscribeButton']: YouTubeSubscribeButton,
  ['BlocksDemo']: BlocksDemo,
  ['LottieEmbed']: LottieEmbed,
  ['MockLibComp']: MockLibComp,
  ['SimpleCard']: SimpleCard,
  ['Stepper']: Stepper
};


// temporary export
export const version = "1.0.0"
